import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateNoticeListMutation,
  CreateNoticeListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";

const createNoticeListMutation = graphql(`
  mutation createNoticeList($input: CreateNoticeListInput!) {
    createNoticeList(input: $input) {
      id
      name
    }
  }
`);

export function useCreateNoticeList(
  options?: UseMutationOptions<
    CreateNoticeListMutation,
    unknown,
    CreateNoticeListMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const queryClient = useQueryClient();
  return useGraphQlMutation(createNoticeListMutation, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      await queryClient.invalidateQueries(["noticeLists"]);
      const list = data.createNoticeList;
      logEvent(EventNames.listCreated, {
        "User List name": list.name,
        "User List id": list.id,
        "Data type": EventDataTypes.recordList,
      });
      options?.onSuccess?.(data, vars, ctx);
    },
  });
}
